import styled, { keyframes } from 'styled-components';

export const LoadingSpinnerContainer = styled.div`
  display: flex;
  flex-direction: ${props => (props.row ? 'row' : 'column')};
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 20px;
`;

export const Heading = styled.h1`
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  color: #0e141d;
  margin: ${props => (props.row ? '0px 10px' : '10px 0px 0px')};
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => (props.small ? '20px' : '40px')};
  height: ${props => (props.small ? '20px' : '40px')};
  border-radius: 50%;
  background: conic-gradient(
    from 90deg at 50% 50%,
    rgba(233, 32, 112, 0.0001) 0deg,
    #ff127a 359.96deg,
    rgba(233, 32, 112, 0.0001) 360deg
  );
  animation: ${rotate} 0.8s linear infinite;

  :before {
    content: '';
    width: ${props => (props.small ? '13px' : '26px')};
    height: ${props => (props.small ? '13px' : '26px')};
    background: white;
    border-radius: 50%;
  }
`;

export const Body = styled.span`
  margin: 24px 0;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  max-width: 200px;
  color: #494c66;
`;
